enum RenewalRequestStatus {
    /** Created from external application */
    Reminder = 0,
    /** Init by customer */
    Waiting = 1,
    Processing = 2,
    Cancelled = 3,
    Rejected = 4,
    Completed = 5,
    ResponseSent = 6,
    NotContacted = 7,
    Lost = 9
}

export default RenewalRequestStatus;